import { render, staticRenderFns } from "./CalendarSelector.vue?vue&type=template&id=4faeb1de&"
import script from "./CalendarSelector.vue?vue&type=script&lang=js&"
export * from "./CalendarSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports